import { ErrorDialog } from 'src/components/error-dialog';
import { withDialog } from 'shared/hocs/with-dialog';

export const withErrorDialog = withDialog(ErrorDialog, {
  propName: 'errorDialog'
});
